var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui container"},[_c('div',{staticClass:"ui grid"},[_c('div',{staticClass:"sixteen wide column"},[_c('div',{staticClass:"home"},[(_vm.arePreackAndFlowLoaded)?[_c('Header',{attrs:{"title":_vm.getTitle}}),_c('Timeline',{attrs:{"flowData":_vm.flowData},on:{"updatedModules":_vm.handleUpdatedModules}})]:_vm._e()],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }